import gql from 'graphql-tag';

export const ModalSidebarListingFragment = gql`
  fragment ModalSidebarListingFragment on Listing {
    _id
    id
    title
    slug
    condition {
      displayName
    }
    images(input: { transform: "card_square" }) {
      source
    }
  }
`;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/components/modal_sidebar_listing_operations.ts